import { COMPANY, NAV_LINKS, waLink } from "@/lib/site";
import { MessageCircle, Mail, MapPin } from "lucide-react";
import { getProductNameFromPath, trackEvent } from "@/lib/analytics";
import { useLocation } from "react-router-dom";

export const Footer = () => {
  const { pathname } = useLocation();
  const productName = getProductNameFromPath(pathname);

  return (
    <footer data-testid="site-footer" className="bg-animax-black text-white pt-20 pb-8 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-animax-yellow/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-12 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="inline-flex items-center gap-4 rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3 shadow-[0_18px_50px_-35px_rgba(255,255,255,0.35)]">
              <div className="h-12 w-28 flex items-center justify-center">
                <img
                  src={COMPANY.logos.animaxBadge}
                  alt="ANIMAX"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <div className="h-10 w-px bg-white/15" />
              <div className="h-12 w-28 rounded-md bg-white flex items-center justify-center p-2">
                <img
                  src={COMPANY.logos.animaxFull}
                  alt="ANIMAX Acrylic Sheet"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            </div>
            <div className="mt-6">
              <p className="font-display text-xl text-white leading-tight max-w-md">
                {COMPANY.name}
              </p>
              <div className="mt-3 inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1.5 text-sm font-medium text-white/75">
                <MapPin className="w-3.5 h-3.5 text-animax-yellow shrink-0" />
                Mojokerto, Indonesia
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="tag-uppercase text-white/60 mb-4">Navigasi</div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace(/[\/#]/g, "")}`}
                    className="text-sm text-white/80 hover:text-animax-yellow transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="tag-uppercase text-white/60 mb-4">Kontak</div>
            <div className="space-y-3">
              {COMPANY.whatsapp.map((w, i) => (
                <a
                  key={i}
                  href={waLink(w.raw, "Halo, saya ingin bertanya tentang produk PT. Animax Putra Lancar")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-wa-${i}`}
                  onClick={() =>
                    trackEvent("whatsapp_button_clicked", {
                      category: "contact",
                      label: w.name,
                      source: "footer",
                      sales_name: w.name,
                      product_name: productName,
                    })
                  }
                  className="flex items-center gap-2 text-sm text-white/80 hover:text-animax-yellow"
                >
                  <MessageCircle className="w-4 h-4" />
                  {w.number} <span className="text-white/40">· {w.name}</span>
                </a>
              ))}
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-center gap-2 text-sm text-white/80 hover:text-animax-yellow break-all">
                <Mail className="w-4 h-4 shrink-0" />
                {COMPANY.email}
              </a>
              <div className="flex items-start gap-2 text-sm text-white/80">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{COMPANY.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} PT. Animax Putra Lancar. Seluruh hak cipta dilindungi.
          </p>
          <p className="text-xs text-white/50">
            Trading Material untuk Kebutuhan Proyek & Industri · Mojokerto, Jawa Timur, Indonesia
          </p>
        </div>
      </div>
    </footer>
  );
};
